// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const BOTTOM_WINDOWS_MARGIN = 32;
export const TOP_WINDOWS_MARGIN = 56;
export const WINDOW_SIDE_BORDERS_WIDTH = 4;
export const MENU_TOP_OFFSET = 4;
export const AUTO_HIDE_BLOCK_WIDTH = 24;
export const AUTO_HIDE_AVALIABLE_PANELS_COUNT = 3;
export const TOP_BOTTOM_PADDING_OFFSET = 4;
export const PADDING_OFFSET_LEFT = 4;
export const SYMBOL_INFO_PANEL_WIDTH = 500;
export const SYMBOL_INFO_PANEL_HEIGHT = 588;
